export default __webpack_public_path__ + "static/media/evm.ec61a3a7.png";